module.exports = __webpack_public_path__ + "img/naga.83b16bcc.png";